var _linearGradient, _linearGradient2, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_2",
    gradientUnits: "userSpaceOnUse",
    x1: 6,
    x2: 506,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2bc4f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00aeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095da"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 163.853,
    x2: 440.821,
    y1: 147.75,
    y2: 424.718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#Blue_2)",
    r: 250
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m502.205 299.59-171.168-171.169h-147.855l-13.93 130 6.364 8.239 30.529 30.528h-43.072c0 23.881 8.528 44.461 23.247 59.537l139.405 139.409c90.54-26.244 159.907-102.294 176.48-196.544z",
    fill: "url(#linear-gradient)",
    opacity: 0.49
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m254.689 213.728c55.842 0 94.238 34.181 94.238 83.079 0 50.659-38.83 86.772-93.218 86.772-54.342 0-92.636-35.783-92.636-86.387h63.963c0 16.932 11.9 29.045 28.673 29.045 16.4 0 28.355-12.548 28.355-29.435 0-17.91-12.549-30.138-30.834-30.138h-77.614l-6.364-8.239 13.93-130h147.855v56.844h-96.414l-3.142 28.456h23.2z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.ca8f84278f8f39b12c4ab347d63ae116.svg";
export { ForwardRef as ReactComponent };